<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Failed Posts</div>
            </div>

            <!--page content-->
            <div class="admin-page-content">
                <div class="app-filter-good-table-container">
                    <!-- List Content Here -->
                    <vue-good-table
                        ref="listsocialaccount"
                        mode="remote"
                        title="List of Faild Post"
                        @on-page-change="onPageChange"
                        @on-selected-rows-change="selectionChanged"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                            enabled: true,
                            mode: 'pages',
                            pageLabel: 'Page',
                            position: 'bottom',
                            perPage: serverParams.perPage,
                            perPageDropdown: [25, 50, 100, 200 ,500],
                            dropdownAllowAll: false,
                        }"
                        :selectOptions="{
                            enabled: true,
                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                            selectionInfoClass: 'custom-class',
                            selectionText: 'rows selected',
                            clearSelectionText: 'clear',
                        }"
                        :search-options="{
                          enabled: false,
                        }">

                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <!--class="btn btn-xs btn-primary"-->
                                <div v-if="props.column.field == 'action'" class="table-action">
                                    <i title='View Faild Post' class="fa fa-eye btn edit-btn-vvg waves-effect" aria-hidden="true" v-on:click.prevent="viewFailedPost(props.row.sid)"></i>
                                    <a title='Post Again' id="delete" class="btn edit-btn-vvg waves-effect"  v-on:click.prevent="postAgain([props.row])">
                                      <i class="fa fa-paper-plane" aria-hidden="true"></i>
                                    </a>
                                </div>

                                <div v-if="props.column.field == 'media_type'">
                                  <template v-if="props.row.media_type != null">
                                    {{ capitalizeFirstLetter(props.row.media_type) }}
                                  </template>
                                </div>

                                <!--div v-else-if="props.column.field == 'post_date'">
                                  {{ props.row.post_date }}
                                   TO
                                  {{ props.row.end_date_time }}
                                </div>

                                <div v-else-if="props.column.field == 'created_by'">
                                  {{ capitalizeFirstLetter(props.row.created_by) }}
                                </div-->

                                <div v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </div>
                            </div>
                        </template>

                        <div slot="selected-row-actions" slot-scope="computed">
                            {{computed.selectedRows}}
                            <!--button data-toggle="modal" id="changeRoleModel" title='Change role' class="btn btn-primary" data-target="#changeRole" >Change Role</button-->
                            <!--<button data-toggle="modal" id="changeLocationModel" title='Change location' class="btn btn-primary" data-target="#changeLocation" >Change Location</button>-->
                            <button title='Post Again' id="deleteMultiple" class="btn btn-primary" v-on:click.prevent="postAgain($refs['listsocialaccount'].selectedRows)">Post Again ({{selectedRows}})</button>

                        </div>

                    </vue-good-table>

                </div>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->

</template>

<script>
  import Vue from 'vue';
  import BackendFooter from '@/components/backend/partials/Footer';
  import VueGoodTable from 'vue-good-table';
  import 'vue-good-table/dist/vue-good-table.css';
  Vue.use(VueGoodTable);
  import SessioMixin from '../../../mixins/sessionmixin';
  import { HTTP } from '../../../http-common';

  var self;

export default {
  name: 'FailedPost',
  components: {
      'app-backend-footer': BackendFooter,
  },
  mixins: [SessioMixin],
  data() {
    return {
        columns: [
        {
              label: 'Social Media',
              field: 'media_type',
              filterable: true,
              filterOptions: {
                  enabled: true, // enable filter for this column
                  placeholder: "Social Media", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  filterDropdownItems: [], // dropdown (with selected values) instead of text input
                  filterFn: this.onColumnFilter, //custom filter function that
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
                label: 'Company',
                field: 'company',
                filterable: true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Company", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Description',
                field: 'description',
                filterable: true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Description", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Has Tags',
                field: 'has_tags',
                filterable: true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Has Tags", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Contact Email',
                field: 'contact_email',
                filterable: true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "Contact Email", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Media',
                field: 'media',
                filterable: true,
                sortable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Media", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            // {
            //     label: 'Posts',
            //     field: 'post',
            //     filterable: true,
            //     filterOptions: {
            //         enabled: true, // enable filter for this column
            //         placeholder: "Post", // placeholder for filter input
            //         filterValue: '', // initial populated value for this filter
            //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
            //         filterFn: this.onColumnFilter, //custom filter function that
            //         trigger: "enter" //only trigger on enter not on keyup
            //     }
            // },
            {
                label: 'Post Date',
                field: 'post_date',
                filterable: true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "YYYY-MM-DD", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Failed Date',
                field: 'failed_date',
                filterable: true,
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: "YYYY-MM-DD", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            // {
            //     label: 'Posted_Date',
            //     field: 'posted_by',
            //     filterable: true,
            //     filterOptions: {
            //         enabled: true, // enable filter for this column
            //         placeholder: "Posted By", // placeholder for filter input
            //         filterValue: '', // initial populated value for this filter
            //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
            //         filterFn: this.onColumnFilter, //custom filter function that
            //         trigger: "enter" //only trigger on enter not on keyup
            //     }
            // },
            {
                label: 'Actions',
                field: 'action',
                html: true,
                sortable: false,
                thClass: 'disable-sorting',
            },
        ],
        rows: [],
        totalRecords: 0,
        serverParams: {
            columnFilters: {},
            page: 1,
            perPage: 25,
            sort: {
                field: 'id',
                type: 'asc',
            },
        },
        recordsCounts: "",
        selectedRows: 0,
        firstLoad: 0,
    }
  },
  beforeMount: function () {
      self = this;
      self.checkLogin();
      self.getListFailedPost()
  },
  methods: {
    postAgain(selectedPost) {
      console.log("POST AGAIN", selectedPost);
      // var selectedPost = self.$refs['listsocialaccount'].selectedRows;
      var idsList = [];
      for (var i = 0; i < selectedPost.length; i++) {
          idsList.push(selectedPost[i].id);
      }
      console.log(idsList);
      var config = {
          headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
      };
      var fields = {
          ids: idsList,
      };
      self.showLoader();
      HTTP.post('socialmedia/post/failed', fields, config)
          .then(function (response) {
            console.log(response.data);
            if (response.data === "done") {
              self.$swal('Post', 'Post published successfully', 'success');
              self.getListFailedPost();

            }
            self.hideLoader();
          })
          .catch(function (err) {
            console.log("err =", err);
              if (err.response.status == 0) {
                  if (err.response.status == 0) {
                      self.error = "Remote server can not be reachable";
                  } else {
                      //redirect to login page if user not authenticated
                      if (err.response.status == 401) {
                          //clear previous data
                          localStorage.removeItem("user_obj");
                          localStorage.removeItem("api_token");
                          localStorage.removeItem("profile_image");
                          self.$router.push("/login");
                          //EventBus.$emit("logged-in", true, "", "");
                      }
                      self.error = err.response.data.message;
                  }
              }
              self.hideLoader();
          });


    },
    viewFailedPost: function(id) {
      self.$router.push("/backend/failed/post?id=" + id);
    },
    getListFailedPost: function () {
      self.firstLoad = 1;
      var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage)
      if (newPage) {
          if (newPage < self.serverParams.page) {
              self.serverParams.page = newPage;
          }
      }
      var config = {
          headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
      };
      var fields = {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: self.serverParams.columnFilters,
          // messageData: self.message,
          sort: self.serverParams.sort,
          // year: self.year
      };
      self.showLoader();
      HTTP.post('socialmedia/failed/posts', fields, config)
          .then(function (response) {
            console.log(response);
              if (response.data.code == '200') {
                  self.rows = response.data.content.row;
                  console.log(self.rows);
                  self.totalRecords = response.data.content.totalRecords;
              }
              self.hideLoader();
          })
          .catch(function (err) {
              if (err.response.status == 0) {
                  if (err.response.status == 0) {
                      self.error = "Remote server can not be reachable";
                  } else {
                      //redirect to login page if user not authenticated
                      if (err.response.status == 401) {
                          //clear previous data
                          localStorage.removeItem("user_obj");
                          localStorage.removeItem("api_token");
                          localStorage.removeItem("profile_image");
                          self.$router.push("/login");
                          //EventBus.$emit("logged-in", true, "", "");
                      }
                      self.error = err.response.data.message;
                  }
              }
              self.hideLoader();
          })


    },
    updateParams(newProps) {
        self.serverParams = Object.assign({}, self.serverParams, newProps);
    },
    //
    onPageChange(params) {
        self.updateParams({page: params.currentPage});
        self.getListFailedPost();
    },
    onPerPageChange(params) {
        if (params.currentPerPage != self.serverParams.perPage) {
            self.updateParams({perPage: params.currentPerPage});
            self.totalRecords = self.totalRecords;
            self.getListFailedPost();
        }
    },
    selectionChanged() {
        var self = this;
        self.selectedRows = (self.$refs['listsocialaccount'].selectedRows).length;
        /*console.log(self.selectedRows);*/
    },
    onColumnFilter(params) {
        self.updateParams(params);
        {
            field: ('first_name');
            field: ('last_name');
            field: ('dayforce_id');
            field: ('location_name');
            field: ('role_name');
            field: ('updated_by');
        }
        ;
        self.serverParams.page = 1;
        var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
        var filters = filtersPr.columnFilters;

        if (self.firstLoad == 1 || filters.first_name || filters.last_name || filters.dayforce_id || filters.location_name || filters.role_name || filters.updated_by) {
            self.getListFailedPost();
        }

    },
    onSortChange(params) {
        self.updateParams({
            sort: {
                type: params[0].type,
                field: params[0].field,
            },
        });
        self.getListFailedPost();
    },

  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/backend/socialmedia/FailedPost.vue